module.exports = __webpack_public_path__ + "img/virtuous-veterans.a2227628.png";